import { render } from "./OscarPoolResultsNewsFeed.vue?vue&type=template&id=3088dd3e"
import script from "./OscarPoolResultsNewsFeed.vue?vue&type=script&lang=js"
export * from "./OscarPoolResultsNewsFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__